import { useEffect } from 'react';
import { auth } from "../Firebase/firebase";
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const useSessionTimeout = (timeoutMinutes) => {
  const navigate = useNavigate();
  
  useEffect(() => {
    let timeoutId;
    const timeoutMilliseconds = timeoutMinutes * 60 * 1000;

    const resetTimer = () => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(logout, timeoutMilliseconds);
    };

    const logout = async () => {
      try {
        await signOut(auth);
        //localStorage.clear(); // Clear all local storage on session timeout
        navigate('/LoginPage');
        Swal.fire({
          toast: true,
          icon: 'info',
          title: 'Session expired',
          text: 'You have been logged out due to inactivity',
          position: 'top-end',
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
      } catch (error) {
        console.error('Logout error:', error);
      }
    };

    // Events that indicate user activity
    const events = ['mousedown', 'keydown', 'scroll', 'touchstart', 'mousemove'];
    
    // Add event listeners
    events.forEach(event => window.addEventListener(event, resetTimer));
    
    // Initialize timer
    resetTimer();

    // Cleanup function
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      events.forEach(event => window.removeEventListener(event, resetTimer));
    };
  }, [navigate, timeoutMinutes]);
};

export default useSessionTimeout;